import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

interface SpacerProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The flex value to control how much space the spacer takes.
   * Default is 1, which makes it grow equally with other flex items.
   * Higher values take more space.
   */
  flex?: number;
}

const Spacer = forwardRef<HTMLDivElement, SpacerProps>(({ className, flex = 1, ...props }, ref) => (
  <div ref={ref} className={cn('flex', className)} style={{ flex }} {...props} />
));

Spacer.displayName = 'Spacer';

export { Spacer };
export type { SpacerProps };
